import I18n from 'lib/i18n'
import React from 'react'
import Checkbox from 'lib/forms/checkbox-svg'
import './styles.scss'
import { connect } from 'kea'
import filtersLogic from '~/scenes/search/filters-page/logic'
import searchLogic from '~/scenes/search/logic'
import PropTypes from 'prop-types'

@connect({
  actions: [filtersLogic, ['updateUnsavedFilter'], searchLogic, ['receiveResults']],
  props: [filtersLogic, ['unsavedFilter'], searchLogic, ['results', 'filter']]
})
export default class TeacherLocation extends React.Component {
  static propTypes = {
    countries: PropTypes.array.isRequired,
    teacher_country_code: PropTypes.string,
    results: PropTypes.object,
    filter: PropTypes.object,
    unsavedFilter: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      suggestions: [],
      text: '',
      countryCode: '',
      inputClicked: false
    }
  }

  componentDidMount () {
    const { countries, teacher_country_code: teacherCountryCode } = this.props.unsavedFilter
    const { text } = this.state
    const currentCountry = countries.filter(obj => teacherCountryCode === obj.value)[0]
    const textValue = teacherCountryCode && !text ? currentCountry.label : text
    this.setState(() => ({ text: textValue }))
  }

  handleTextChange = e => {
    const { countries } = this.props.unsavedFilter
    const countryList = countries.map(country => country.label)
    const value = e.target.value
    let suggestions = []
    if (value && value.length > 0) {
      const regex = new RegExp(`^${value}`, 'i')
      suggestions = countryList.sort().filter(v => regex.test(v))
    }
    this.setState(() => ({
      suggestions,
      text: value,
      countryCode: ''
    }))
  }

  suggestionSelected (value) {
    const { countries } = this.props.unsavedFilter
    const { updateUnsavedFilter } = this.actions
    const country = countries.filter(obj => value === obj.label)[0]
    this.setState(() => ({
      text: value,
      suggestions: [],
      countryCode: country.value
    }))
    updateUnsavedFilter({ teacher_country_code: country.value })
  }

  renderSuggestions () {
    const { suggestions } = this.state
    if (suggestions.length === 0) {
      return null
    }
    return (
      <div>
        {suggestions.map(country => (
          <p key={country} onClick={() => this.suggestionSelected(country)} className='super-label suggestions-result'>
            {country}
          </p>
        ))}
      </div>
    )
  }

  onChangeLocationType (isWebcam) {
    const { updateUnsavedFilter } = this.actions
    updateUnsavedFilter({ webcam_anywhere: isWebcam, teacher_country_code: '' })
    this.setState(() => ({ text: '' }))
  }

  handleBlur = () => {
    this.setState({ inputClicked: false })
  }

  handleFocus = () => {
    const { results, filter } = this.props
    const { receiveResults } = this.actions
    const {
      helmet,
      helmet: { meta }
    } = results
    this.setState({ inputClicked: true })
    // quirky fix to prevent automatic zoom for iphone
    const metaArray = meta.filter(metaTag => metaTag.name !== 'viewport')
    receiveResults(
      {
        ...results,
        helmet: {
          ...helmet,
          meta: [
            ...metaArray,
            { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0' }
          ]
        }
      },
      filter
    )
    this.onChangeLocationType(false)
  }

  render () {
    const { text, inputClicked } = this.state
    const { webcam_anywhere: webcamAnywhere } = this.props.unsavedFilter
    return (
      <div className='filter-section'>
        <div className='filter-title'>{I18n.t('react.search.filters.teacher_location.placeholder')}</div>
        <div className='checkbox-list'>
          <Checkbox checked={webcamAnywhere} onChange={() => this.onChangeLocationType(true)}>
            {I18n.t('react.search.filters.teacher_location.anywhere')}
          </Checkbox>
          <Checkbox checked={!webcamAnywhere} onChange={() => this.onChangeLocationType(false)}>
            {I18n.t('react.search.filters.teacher_location.location')}
          </Checkbox>
        </div>
        <input
          type='text'
          className={`${inputClicked ? 'teacher-location-input input-clicked' : 'teacher-location-input'}`}
          placeholder={I18n.t('react.search.filters.teacher_location.location_placeholder')}
          value={text}
          onChange={this.handleTextChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        {this.renderSuggestions()}
      </div>
    )
  }
}
